<template>
  <div>
    <div v-if="Lib.checkPower('beauty-3-ckgkkfjl2',2)">
      <el-table v-loading="loading" tooltip-effect="light" :data="room_record_data" style="width: 100%">
        <el-table-column prop="createTime" label="预订时间">
          <template slot-scope="scope">
            {{ scope.row.createTime || '--' }}
          </template>
        </el-table-column>

        <el-table-column label="订单号" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.orderCode || '--' }}
          </template>
        </el-table-column>
        <!--5.10新.使用时间，2.离店时间，3.使用时长，4.状态-->
        <el-table-column label="使用时间">
          <template slot-scope="scope">
            <span>{{ scope.row.beginTime || '--' }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="endTime" label="离店时间">
          <template slot-scope="scope">
            <span>{{ scope.row.endTime || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dateTime" label="使用时长">
          <template slot-scope="scope">
            {{ Lib.calculationTime(scope.row.dateTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="状态">
          <template slot-scope="scope">
            <!-- 1 锁定 2 已预订  3 入住 5 已退房 6 过期 7 超时 8 取消 -->
            <p v-if="scope.row.infoType === 2" style="color:#999999;font-size:14px">已预订</p>
            <p v-if="scope.row.infoType === 3" style="color:#67C23A;font-size:14px">已使用</p>
            <p v-if="scope.row.infoType === 7" style="color:#999999;font-size:14px">已超时</p>
            <p v-if="scope.row.infoType === 5" style="color:#999999;font-size:14px">{{ getRoomType==1?'已退房':'已退位' }}</p>
            <p v-if="scope.row.infoType === 6" style="color:#999999;font-size:14px">已过期</p>
            <p v-if="scope.row.infoType === 8" style="color:#999999;font-size:14px">已取消</p>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.infoType === 7 || scope.row.infoType === 3 || scope.row.infoType === 5" size="mini" type="primary" @click="onShowRoomRecords(scope.row)"> {{ getRoomType==1?'房间详情':'床位详情' }}</el-button>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="room_records_total" background layout="prev, pager, next" :current-page.sync="room_records_pageNo" :page-size="10" :total="room_records_total" @current-change="onGetRoomList">
      </el-pagination>
      <yzRoomDetails :show.sync="roomDetailsDialog" :detail-data="detailData" :detail-data-arr="detailData.customerList" :get-room-type="getRoomType" />
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>

<script>
import { getCustomerRoom } from '../api';
import yzRoomDetails from '../../../../stage/template/orderDeatilsData/template/roomDetails';

export default {
  components: {
    yzRoomDetails
  },
  data() {
    return {
      room_record_data: [],
      room_records_pageNo: 1,
      room_records_total: 0,
      orderDeatilsData: [],
      roomDetailsDialog: false,
      detailData: {},
      loading: true,
      getRoomType: window.sessionStorage.tidyStatus, // 设置的房态  1房间  2床位  3台位(5.10)
    };
  },
  activated() {
    this.getRoomType = window.sessionStorage.tidyStatus;// 设置的房态  1房间  2床位  3台位
    this.onGetRoomList();
  },
  methods: {
    // 获取房间列表
    onGetRoomList() {
      this.loading = true;
      const data = {
        phone: this.$parent.customerInfo.phone,
        mainId: sessionStorage.getItem('mainId'),
        pageNo: this.room_records_pageNo,
        pageSize: 10
      };
      getCustomerRoom(data).then((res) => {
        this.room_record_data = res.data.records;
        this.room_records_total = res.data.total;
        this.loading = false;
        console.log('res.data.records', res.data.records);
      });
    },
    // 展示房间详情
    onShowRoomRecords(row) {
      console.log('详情', row);
      this.detailData = row;
      this.roomDetailsDialog = true;
    }
  }
};
</script>
<style lang="less" scoped>
.no_data {
    text-align: center;
    padding: 30px;
    margin: 10px;
    margin-top: 0px;
    border: solid 1px #d8dce5;
    span {
        font-size: 14px;
        color: #999999;
        margin-top: 17px;
    }
}
</style>
